import React from "react"
import clsx from "clsx"

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  headingLevel: "h1" | "h2" | "h3" | "card-title"
}

export const Heading: React.FC<HeadingProps> = ({
  headingLevel,
  className,
  children,
  ...props
}) => {
  switch (headingLevel) {
    case "h1":
      return (
        <h1
          className={clsx(
            "font-urbanist font-semibold sm:text-4xl sm:leading-[52px]",
            "text-2xl leading-[36px]",
            className
          )}
          {...props}
        >
          {children}
        </h1>
      )
    case "h2":
      return (
        <h2
          className={clsx(
            "font-urbanist font-semibold sm:text-2xl sm:leading-[36px]",
            " leading-[24px]",
            className
          )}
          {...props}
        >
          {children}
        </h2>
      )
    case "h3":
      return (
        <h3 className={clsx("font-urbanist", className)} {...props}>
          {children}
        </h3>
      )
    case "card-title":
      return (
        <div {...props} className={clsx("font-semibold sm:", "text-sm", className)}>
          {children}
        </div>
      )
    default:
      return (
        <div className={className} {...props}>
          {children}
        </div>
      )
  }
}
